import { Injectable } from '@angular/core';
import {
  BaseControlType,
  DropdownControlType,
  NumberControlType,
  TextControlType,
} from './views/main-forms/BaseControlType';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Environment } from 'src/environments/environment';
import { patient } from './views/interface/patientInterface';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ControlTypeServiceService {
  getAllPatientsFromCache: any;
  getCreatePatientsDropdownFromCache: any;
  getCreateExposureDropdownFromCache: any;
  getSubmitCDDCaseFromCache: any;
  dropdowns: any;

  getCreateCasesFromCache: any;

  notificationId = new BehaviorSubject<any>("");
  amrNotificationId = new BehaviorSubject<any>("");
  private records: any[] = [];
  private recordSubject = new BehaviorSubject<any[]>([]);
  records$: Observable<any[]> = this.recordSubject.asObservable();

  private idnNotificationrecords: any[] = [];
  private idnNotificationRecordSubject = new BehaviorSubject<any[]>([]);
  idnNotificationRecords$: Observable<any[]> =
    this.idnNotificationRecordSubject.asObservable();

  private cddrecords: any[] = [];
  private cddRecordSubject = new BehaviorSubject<any[]>([]);
  cddRecords$: Observable<any[]> =
    this.cddRecordSubject.asObservable();

  private amrRecords: any[] = [];
  private amrRecordSubject = new BehaviorSubject<any[]>([]);
  amrRecords$: Observable<any[]> = this.amrRecordSubject.asObservable();

  private caseSearchRecords: any[] = [];
  private caseSearchRecordsSubject = new BehaviorSubject<any[]>([]);
  caseSearchRecordsSearch$: Observable<any[]> =
    this.caseSearchRecordsSubject.asObservable();

  private systemSettingRecords: any[] = [];
  private systemSettingRecordSubject = new BehaviorSubject<any[]>([]);
  systemSettingRecord$: Observable<any[]> = this.systemSettingRecordSubject.asObservable();

  private fmProfileRecords: any[] = [];
  private fmProfileRecordSubject = new BehaviorSubject<any[]>([]);
  fmProfileRecord$: Observable<any[]> = this.fmProfileRecordSubject.asObservable();

  private clusterRecords: any[] = [];
  private clusterRecordSubject = new BehaviorSubject<any[]>([]);
  clusterRecords$: Observable<any[]> = this.clusterRecordSubject.asObservable();

  private cddUserRecords: any[] = [];
  private cddUserSubject = new BehaviorSubject<any[]>([]);
  cddUserRecords$: Observable<any[]> = this.cddUserSubject.asObservable();

  private bulkMonitoringRecords: any[] = [];
  private bulkMonitoringSubject = new BehaviorSubject<any[]>([]);
  bulkMonitoringRecords$: Observable<any[]> = this.bulkMonitoringSubject.asObservable();


  private apiUrl = Environment.apiUrl;
  private integrationURL = Environment.integrationURL;
  constructor(private http: HttpClient) { }

  //#region CaseAPI
  submitCase(payLoad: any, isDraft: boolean) {
    const draftQuery = isDraft ? `?isDraft=true` : '?isDraft=false';
    return this.http.post(
      `${this.apiUrl}/api/Case/CreateCase${draftQuery}`,
      payLoad
    );
  }

  updateCase(payLoad: any, isDraft?: boolean) {
    if (isDraft) {
      return this.http.post(`${this.apiUrl}/api/Case/UpdateDraftCase`, payLoad);
    } else {
      return this.http.post(
        `${this.apiUrl}/api/Case/CreateCase?isDraft=false`,
        payLoad
      );
    }
  }

  updateCddCase(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Case/UpdateCase`, payLoad);
  }
  downloadTbFileByID(id: any) {
    return this.http.get(`${this.apiUrl}/api/NotifcationStage/DownloadFile/${id}`);
  }
  SubmitStage(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Case/SubmitStage`, payLoad);
  }
  MapToShifaa(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/NotifcationStage/MapToShifaa`, payLoad);
  }
  getAllIDNDisease() {
    return this.http.get<any>(`${this.apiUrl}/api/IDNDisease/GetAllIDNDisease`);
  }
  getAllStages() {
    return this.http.get<any>(`${this.apiUrl}/api/IDNDisease/GetStages`);
  }
  GetCaseManagementStatistic(DiseaseID = null) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    let param: string = DiseaseID == null ? "" : `${DiseaseID}`.toString();
    return this.http.post<any>(
      `${this.apiUrl}/api/Case/GetCaseManagementStatistic`,JSON.stringify(param), { headers}
    );
  }

  getDynamicFields(id: any,subTypes:any = null) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    let payload = {
      diseaseId: id,
      subTypes
    }
    return this.http.post<any>(
      `${this.apiUrl}/api/Case/CaseDiseaseForm`,JSON.stringify(payload), { headers}
    );
  }

  getDynamicTableByDisease(id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/api/DynamicTable/GetDynamicTableByDisease?Disease=` +
      encodeURIComponent(id)
    );
  }

  getDefaultsDynamicTable() {
    return this.http.get<any>(
      `${this.apiUrl}/api/DynamicTable/GetDynamicTableByDisease`
    );
  }

  // createCase(Disease: any){
  //   return this.http.get<any>(`${this.apiUrl}/api/Case/CreateCase/` + encodeURIComponent(Disease))
  // }

  // getCaseById(Disease: any, reqId: any) {
  //   return this.http.get<any>(
  //     `${this.apiUrl}/api/Case/GetCaseById/` +
  //       reqId +
  //       `/` +
  //       encodeURIComponent(Disease)
  //   );
  // }

  getPatientDataByEmiratesId(EmiratesId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/api/Patient/GetPatientByEmiratesId?EmiratesId=` +
      EmiratesId
    );
  }

  getPatientDataFromICA(payload: any) {
    const header = new HttpHeaders({
      'content-type': 'application/json',
    });
    return this.http.post<any>(
      `${this.apiUrl}/api/MOI/PersonalProfileDetail`,
      payload,
      { headers: header }
    );
  }

  //#endregion

  //#region /* patients */

  // url = `https://prpapisdev.doh.gov.ae/idnweb/api/`

  updateRecords(newRecords: any[]) {
    this.records = newRecords;
    this.recordSubject.next(this.records);
  }
  /* ends here */

  getAllPatientData(params: any): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/Patient/GetAllPatient`, {
      params,
    });
  }
  /* ends here */

  getCaseById(reqId: any) {
    return this.http.get<any>(`${this.apiUrl}/api/Case/GetCaseById/` + reqId)
      .pipe(
        map((decryptedData: any) => {
          return decryptedData;  // Decrypted data is of any type
        })
      );
  }

  changeCaseDisease(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Case/changeCaseDisease/`, payLoad);
  }

  getCaseById_CDD(reqId: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/Case/GetCaseById_CDD/` + reqId);
  }
  getCaseById_CDD_Old(reqId: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/Case/GetCaseById_CDD_OLD/` + reqId);
  }
  getAMRNotificationById(reqId: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/AMRNotification/GetAMRNotificationById/${reqId}`);
  }
  /* ends here */

  PersonTravelHistory(obj: any) {
    return this.http.post(
      `${this.apiUrl}/api/ICA/PersonTravelHistory`,
      obj
    );
  }

  getIDNDiseaseByID(diseaseId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/api/IDNDisease/GetIDNDiseaseByID/` + diseaseId
    );
  }

  updateIDNDisease(payLoad: any) {
    return this.http.post(
      `${this.apiUrl}/api/IDNDisease/UpdateIDNDisease/`,
      payLoad
    );
  }

  updateIDNGroup(payLoad: any) {
    return this.http.post(
      `${this.apiUrl}/api/IDNDisease/UpdateIDNGroup/`,
      payLoad
    );
  }

  updateIDNDiseaseGroup(payLoad: any) {
    return this.http.post(
      `${this.apiUrl}/api/IDNDisease/updateIDNDiseaseGroup/`,
      payLoad
    );
  }

  removeDiseaseFromGroup(payLoad: any) {
    return this.http.post(
      `${this.apiUrl}/api/IDNDisease/RemoveDiseaseFromGroup`,
      payLoad
    );
  }

  getSubTypes(name: any) {
    return this.http.get<any>(`${this.apiUrl}/api/IDNDisease/GetSubTypes?name=${name}` );
  }
  // getAllPatientData(){
  //   if(this.getAllPatientsFromCache){
  //     return of(this.getAllPatientsFromCache)
  //   }
  //   else {
  //     return this.http.get(`${this.apiUrl}/api/Patient/GetAllPatient`).pipe(
  //       tap( data => {
  //         this.getAllPatientsFromCache = data
  //       })
  //     );
  //   }
  // }
  /* ends here */

  GetPatientById(patientId: string) {
    return this.http.get(
      `${this.apiUrl}/api/Patient/GetPatientById/${patientId}`
    );
  }
  /* ends here */

  getCreatePatientsDropdown() {
    if (this.getCreatePatientsDropdownFromCache) {
      return of(this.getCreatePatientsDropdownFromCache);
    } else {
      return this.http.get(`${this.apiUrl}/api/Patient/CreatePatient`).pipe(
        tap((data) => {
          this.getCreatePatientsDropdownFromCache = data;
        })
      );
    }
  }

  getCreateContactExposureDropdown() {
    if (this.getCreateExposureDropdownFromCache) {
      return of(this.getCreateExposureDropdownFromCache);
    } else {
      return this.http.get(`${this.apiUrl}/api/ContactExposure/CreateContactExposure`)
        .pipe(
          tap((data) => {
            this.getCreateExposureDropdownFromCache = data;
          })
        );
    }
  }

  getSubmitCDDCaseDropdown() {
    if (this.getSubmitCDDCaseFromCache) {
      return of(this.getSubmitCDDCaseFromCache);
    } else {
      return this.http
        .get(`${this.apiUrl}/api/Case/SubmitCDDCase`)
        .pipe(
          tap((data) => {
            this.getSubmitCDDCaseFromCache = data;
          })
        );
    }
  }

  SubmitCDDCase(payLoad: any) {
    return this.http.post(
      `${this.apiUrl}/api/Case/SubmitCDDCase`,
      payLoad
    );
  }
  /* ends here */

  getCreateCase(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/Case/CreateCase`);

    // this.getCreateCasesFromCache = sessionStorage.getItem('createCases');
    // if (this.getCreateCasesFromCache) {
    //   return of(this.getCreateCasesFromCache)
    // } else {
    //   return this.http.get(`${this.apiUrl}/api/Case/CreateCase`).pipe(
    //     tap(data => {
    //       // this.getCreateCasesFromCache = data
    //       sessionStorage.setItem('createCases', JSON.stringify(data))
    //     })
    //   );
    // }
  }
  /* ends here */

  getCreateCluster() {
    return this.http.get(`${this.apiUrl}/api/Cluster/CreateCluster`);
  }
  /* ends here */

  addNewPatientData(payLoad: patient) {
    return this.http.post(`${this.apiUrl}/api/Patient/CreatePatient`, payLoad);
  }
  /* ends here */

  UpdatePatientData(data: patient) {
    return this.http.post(`${this.apiUrl}/api/Patient/UpdatePatient`, data);
  }

  // getPatientFilteredData(filters:any){
  //   let params = new HttpParams()
  //   if(filters.passportNumber != null){
  //     params =params.set('PassportNumber', filters.passportNumber)
  //   }
  //   if(filters.gender != null ){
  //     params =params.set('Gender', filters.gender);
  //   }
  //   if(filters.dateOfBirth != null ){
  //     params =params.set('dateOfBirth', filters.dateOfBirth);
  //   }
  //   if(filters.unifiedNumber != null ){
  //     params =params.set('unifiedNumber', filters.unifiedNumber);
  //   }
  //   if(filters.dateOfDeath != null ){
  //     params =params.set('dateOfDeath', filters.dateOfDeath);
  //   }
  //   if(filters.nationality != null ){
  //     params =params.set('nationality', filters.nationality);
  //   }
  //   return this.http.get(`${this.apiUrl}/api/Patient/GetAllPatient`, {params})
  // }

  getPatientByEmiratesId(emiratesId: number) {
    return this.http.get(
      `${this.apiUrl}/api/Patient/GetPatientByEmiratesId?EmiratesId=${emiratesId}`
    );
  }
  /* ends here */

  GetPatientDashboardData() {
    return this.http.get(`${this.apiUrl}/api/Patient/GetPatientDashboardData`);
  }
  /* ends here */

  //#endregion

  //#region /* HCF APIS */

  HCFDashboard_StatusNotification(payload: any) {
    return this.http.get(
      `${this.apiUrl}/HCFDashboard_StatusNotification?FromDate=${payload.fromDate}&ToDate=${payload.toDate}&FacilityID=${payload.facilityID}`
    );
  }
  /* ends here */

  HCFDashboard_TodayNotification(payload: any) {
    return this.http.get(
      `${this.apiUrl}/HCFDashboard_TodayNotification?FromDate=${payload.fromDate}&ToDate=${payload.toDate}&FacilityID=${payload.facilityID}`
    );
  }
  /* ends here */

  HCFDashboard_TotalNotification(payload: any) {
    return this.http.get(
      `${this.apiUrl}/HCFDashboard_TotalNotification?FromDate=${payload.fromDate}&ToDate=${payload.toDate}&FacilityID=${payload.facilityID}`
    );
  }

  HCFDashboard_DiseaseNotification(payload: any) {
    return this.http.get(
      `${this.apiUrl}/HCFDashboard_DiseaseNotification?FromDate=${payload.fromDate}&ToDate=${payload.toDate}&FacilityID=${payload.facilityID}`
    );
  }
  /* ends here */

  GetAllCases(params: any){
    return this.http.post(`${this.apiUrl}/api/Case/GetAllCases`, params);
  }
  GetResultTypesText(){
    return this.http.get(`${this.apiUrl}/api/Case/GetResultTypesText`);
  }
  GetAllCasesMultipleFilters(params: any){
    return this.http.post(`${this.apiUrl}/api/Case/GetAllCasesMultipleFilters`, params);
  }
  /* ends here */

  idnNotificationUpdateRecords(newRecords: any[]) {
    this.idnNotificationrecords = newRecords;
    this.idnNotificationRecordSubject.next(this.idnNotificationrecords);
  }
  /* ends here */

  cddUpdateRecords(newRecords: any[]) {
    this.cddrecords = newRecords;
    this.cddRecordSubject.next(this.cddrecords);
  }
  /* ends here */

  amrNotificationUpdateRecord(newRecords: any[]) {
    this.amrRecords = newRecords;
    this.amrRecordSubject.next(this.amrRecords);
  }

  caseSearUpdateRecords(newRecords: any[]) {
    this.caseSearchRecords = newRecords;
    this.caseSearchRecordsSubject.next(this.caseSearchRecords);
  }

  GetAllIDNDisease_Index() {
    return this.http.get(
      `${this.apiUrl}/api/IDNDisease/GetAllIDNDisease_Index`
    );
  }
  GetAllIDNDiseaseGroup() {
    return this.http.get(`${this.apiUrl}/api/IDNDisease/GetAllIDNGroup`);
  }
  GetAllTargetDisease(){
    return this.http.get(`${this.apiUrl}/api/IDNTargetDisease/GetAllTargetIDNDisease`);
  }

  GetDiseaseGroupByID(IDNGroupID: number) {
    return this.http.get(
      `${this.apiUrl}/api/IDNDisease/GetIDNGroupByID/${IDNGroupID}`
    );
  }

  GetIDNDiseaseByID(IDNDiseaseID: number) {
    return this.http.get(
      `${this.apiUrl}/api/IDNDisease/GetIDNDiseaseByID/${IDNDiseaseID}`
    );
  }

  AddNewIDNDisease(obj: any) {
    return this.http.post(
      `${this.apiUrl}/api/IDNDisease/CreateIDNDisease`,
      obj
    );
  }
  AddNewDiseaseGroup(obj: any) {
    return this.http.post(`${this.apiUrl}/api/IDNDisease/CreateIDNGroup`, obj);
  }

  CreateIDNDiseaseDropdown() {
    return this.http.get(`${this.apiUrl}/api/IDNDisease/CreateIDNDisease`);
  }

  UpdateIDNDisease() {
    return this.http.get(`${this.apiUrl}/api/IDNDisease/UpdateIDNDisease`);
  }

  createContactExposure(payLoad: any) {
    return this.http.post(
      `${this.apiUrl}/api/ContactExposure/CreateContactExposure`,
      payLoad
    );
  }
  createListContactExposure(payLoad: any) {
    return this.http.post(
      `${this.apiUrl}/api/ContactExposure/createListContactExposure`,
      payLoad
    );
  }

  getConactExposure(payload: any) {
    return this.http.get(`${this.apiUrl}/api/ContactExposure/GetContactExposureByPatientID?PatientID=${payload.patientId}&CaseID=${payload.caseId}`);
  }

  getContactExpByContactExpID(contactExpID: any) {
    return this.http.get(`${this.apiUrl}/api/ContactExposure/GetContactExposureByContactExposureID/${contactExpID}`);
  }

  updateContactExposure(payload: any) {
    return this.http.post(`${this.apiUrl}/api/ContactExposure/UpdateContactExposure`, payload);
  }

  deleteContactExposure(payload: any) {
    return this.http.post(`${this.apiUrl}/api/ContactExposure/DeleteContactExposure`, payload);
  }
  
  GetAllExposures(params: any){
    return this.http.post(`${this.apiUrl}/api/ContactExposure/GetAllExposures`, params);
  }

  /* CLUSTER APIS */
  updateClusterRecords(newRecords: any[]) {
    this.clusterRecords = newRecords;
    this.clusterRecordSubject.next(this.clusterRecords);
  }

  updateCddUserRecords(newRecords: any[]) {
    this.cddUserRecords = newRecords;
    this.cddUserSubject.next(this.cddUserRecords);
  }
  updatebulkMonitoringRecords(newRecords: any[]) {
    this.bulkMonitoringRecords = newRecords;
    this.bulkMonitoringSubject.next(this.bulkMonitoringRecords);
  }
  /* ends here */

  getClusterDropdown() {
    return this.http.get(`${this.apiUrl}/api/Cluster/CreateCluster`)
  }

  getAllClusters(params: any) {
    return this.http.post(`${this.apiUrl}/api/Cluster/GetAllClusters`,params );
  }

  filterClustersByName(name: any) {
    return this.http.get(`${this.apiUrl}/api/Cluster/FilterClustersByName?name=${name}`,name );
  }
  /* ends here */

  getClustersById(clusterId: any) {
    return this.http.get(`${this.apiUrl}/api/Cluster/GetClusterById/${clusterId}`);
  }
  /* ends here */

  getClusterCaseByClusterId(clusterId: any) {
    return this.http.get(`${this.apiUrl}/api/Cluster/GetClusterCaseByClusterId/${clusterId}`);
  }

  /* ends here */

  getClusterCaseByClusterId_SQL(clusterId: any) {
    return this.http.get(`${this.apiUrl}/api/Cluster/GetClusterCaseByClusterId_SQL?clusterid=${clusterId}`);
  }
  /* ends here */

  updateCluster(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Cluster/UpdateCluster`, payload);
  }
  /* ends here */

  getClusterStatusCountClusterDashboard(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Cluster/GetClusterStatusCount_ClusterDashboard` ,payload);
  }
  /* ends here */

  getClusterTypeCountClusterDashboard(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Cluster/GetClusterTypeCount_ClusterDashboard` ,payload);
  }

  getSubmittedVsClosedCaseCount(params: any) {
    return this.http.post(`${this.apiUrl}/api/CDDDashboard/CDDDashboard_SubmittedvsDiscarded`,params);
  }
  getMalaffiVsManualEntryCaseCount(params: any) {
    return this.http.post(`${this.apiUrl}/api/CDDDashboard/CDDDashboard_MalaffivsManualEntry`,params);
  }


  /* FOLLOW UP */
  getFollowUpDropdown() {
    return this.http.get(`${this.apiUrl}/api/FollowUp/CreateFollowUp`);
  }
  /* ends here */

  createFollowUp(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/FollowUp/CreateFollowUp`, payLoad);
  }
  /* ends here */

  getFollowUpByNotificationId(id: any) {
    return this.http.get(`${this.apiUrl}/api/FollowUp/GetFollowUpByNotificationID/${id}`);
  }
  /* ends here */

  getFollowUpDataByFollowUpId(followUpId: any) {
    return this.http.get(`${this.apiUrl}/api/FollowUp/GetFollowUpByFollowUpID/${followUpId}`);
  }
  /* ends here */

  updateFollowUp(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/FollowUp/UpdateFollowUp`, payLoad)
  }
  /* ends here */

  deleteFollowUp(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/FollowUp/DeleteFollowUp`, payLoad);
  }
  /* ends here */

  // sms management

  getCreateTemplate() {
    return this.http.get(`${this.apiUrl}/api/Template/CreateTemplate`);
  }
  getTemaplate(params: any) {
    return this.http.post(`${this.apiUrl}/api/Template/GetAllTemplates` , params)
  }

  getTemaplateById(templateID: string) {
    return this.http.get(`${this.apiUrl}/api/Template/GetTemplateByID/${templateID}`);
  }

  updateTemplate(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Template/UpdateTemplate`, payLoad)
  }

  getSmsTemplateDropdown() {
    return this.http.get(`${this.apiUrl}/api/Template/GetAllSMSTemplate`);
  }

  getSmsData(params: any) {
    return this.http.post(`${this.apiUrl}/api/SMS/GetSMSTemplate`, params );
  }

  getSmsTemplateById(templateID: any) {
    return this.http.get(`${this.apiUrl}/api/Template/GetTemplateByID/${templateID}`);
  }

  DeleteTemplateById(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Template/DeleteTemplate`, payLoad);
  }

  createTemplate(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Template/CreateTemplate`, payLoad);
  }

  sendSMS(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/SMS/SendSMS`, payLoad);
  }

  getSMS(param: any) {
    return this.http.post(`${this.apiUrl}/api/SMS/GetAllSMS`, param);
  }

  viewSMSById(id: string) {
    return this.http.get(`${this.apiUrl}/api/SMS/GetSMSByID/${id}`);
  }


  getAllEmail(params: any) {
    return this.http.post(`${this.apiUrl}/api/Email/GetAllEmail`,params);
  }

  viewEmailById(id: string) {
    return this.http.get(`${this.apiUrl}/api/Email/GetEmailByID/${id}`);
  }

  createEmail() {
    return this.http.get(`${this.apiUrl}/api/Email/CreateEmail`);
  }

  GetAllEmailTemplate() {
    return this.http.get(`${this.apiUrl}/api/Template/GetAllEmailTemplate`);
  }
  GetAllEmailTemplateByDiseaseID(diseaseID: string) {
    return this.http.get(`${this.apiUrl}/api/Template/GetAllEmailTemplate/${diseaseID}`);
  }
  GetAllSMSTemplate(diseaseID: string) {
    return this.http.get(`${this.apiUrl}/api/Template/GetAllSMSTemplate/${diseaseID}`);
  }

  sentEmail(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Email/createEmail`, payLoad);
  }

  cddCaseInvestigatorsDropdown() {
    return this.http.get(`${this.apiUrl}/api/Case/SubmitCDDCase`);
  }

  updateCaseAssignee(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Case/UpdateCaseAssignee`, payLoad)
  }

  getTemaplatePlaceholder(templateID: string) {
    return this.http.get(`${this.apiUrl}/api/Template/GetAllTemplatePlaceholderByTemplateID/${templateID}`);
  }
  createTemplatePlaceholder(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Template/CreateTemplatePlaceholder`, payLoad)
  }
  getPlaceholderById(id: string) {
    return this.http.get(`${this.apiUrl}/api/Template/GetTemplatePlaceholderByID/${id}`);
  }
  updatePlaceholder(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Template/UpdateTemplatePlaceholder`, payLoad)
  }
  deleteTemplatePlaceholder(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Template/DeleteTemplatePlaceholder`, payLoad);
  }

  updateBulkNotification(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Case/BulkNotificationStatusUpdate`, payLoad);
  }
  updateClusterStatus(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/Cluster/BulkClusterStatusUpdate`, payLoad);
  }

  /* SYSTEM SETTING */
  GetAllSystemSetting(params: any){
    return this.http.post(`${this.apiUrl}/api/SystemSetting/GetAllSystemSetting`, params);
  }
  /* ends here */

  systemSettingUpdateRecords(newRecords: any[]) {
    this.systemSettingRecords = newRecords;
    this.systemSettingRecordSubject.next(this.systemSettingRecords);
  }
  /* ends here */

  facilityMemberProfileUpdateRecords(newRecords: any[]) {
    this.fmProfileRecords = newRecords;
    this.fmProfileRecordSubject.next(this.fmProfileRecords);
  }
  /* ends here */
  CreateFacility(){
    return this.http.get(`${this.apiUrl}/api/Facility/CreateFacility`);
  }
  GetAllFacilities(params: any){
    return this.http.post(`${this.apiUrl}/api/Facility/GetAllFacilites`, params);
  }
  getFacilityProfileByID(id: any) {
    return this.http.get(`${this.apiUrl}/api/Facility/GetFacilityByID/${id}`);
  }
  updateTestFacility(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Facility/UpdateTestFacility`,payload);
  }
   /* ends here */
  getSystemSettingById(id: any) {
    return this.http.get(`${this.apiUrl}/api/SystemSetting/GetSystemSettingByID/${id}`);
  }

  updateSystemSetting(payload: any) {
    return this.http.post(`${this.apiUrl}/api/SystemSetting/UpdateSystemSetting`, payload);
  }

  /* FACILITY MEMEBER PROFILE */
  GetAllFacilityMemberProfile(params: any) {
    return this.http.post(`${this.apiUrl}/api/FacilityMemberProfile/GetAllFacilityMemberProfile`,params);
  }

  GetFacilityMemberProfileOptionset(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/FacilityMemberProfile/CreateFacilityMemberProfile`);
  }
  /* ends here */

  getFacilityMemberProfileByID(id: any) {
    return this.http.get(`${this.apiUrl}/api/FacilityMemberProfile/GetFacilityMemberProfileByID/${id}`);
  }
  getFacilityMembersProfileByFacility(id: any) {
    return this.http.get(`${this.apiUrl}/api/FacilityMemberProfile/GetAllFacilityMembersByFacility/${id}`);
  }
  /* ends here */

  updateFacilityMemberProfile(payload: any) {
    return this.http.post(`${this.apiUrl}/api/FacilityMemberProfile/UpdateFacilityMemberProfile`, payload);
  }

  getAllCddUsers(params: any) {
    return this.http.post(`${this.apiUrl}/api/CDDUser/GetAllCDDUser`,params );
  }

  getAllTeams(params: any) {
    return this.http.post(`${this.apiUrl}/api/Team/GetAllTeams`, params);
  }

  getAllCddUserById(id: any) {
    return this.http.get(`${this.apiUrl}/api/CDDUser/GetCDDUserByID/${id}`);
  }

  getTeamById(id: any) {
    return this.http.get(`${this.apiUrl}/api/Team/GetTeamByID/${id}`);
  }

  updateTeam(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Team/UpdateTeam`, payload);
  }

  deleteTeam(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Team/DeleteTeam`, payload);
  }

  updateCddUser(payload: any) {
    return this.http.post(`${this.apiUrl}/api/CDDUser/UpdateCDDUser`, payload);
  }

  activeInactiveCDDUser(payload: any) {
    return this.http.post(`${this.apiUrl}/api/CDDUser/ActiveInactiveCDDUser`, payload);
  }

  getCddNationality() {
    return this.http.get(`${this.apiUrl}/api/CDDUser/CreateCDDUser`);
  }

  getAllNationalityByUserId(id: any) {
    return this.http.get(`${this.apiUrl}/api/CDDUser/GetAllNationalityByCDDUserID/${id}`);
  }

  getAllDiseaseByUserId(id: any) {
    return this.http.get(`${this.apiUrl}/api/CDDUser/GetAllDiseaseByCDDUserID/${id}`);
  }

  getAllCddRolesByUserId(id: any) {
    return this.http.get(`${this.apiUrl}/api/CDDUser/GetAllRoleByCDDUserID/${id}`);
  }

  addCddNationality(payload: any) {
    return this.http.post(`${this.apiUrl}/api/CDDUser/AddCDDUser_Nationality`, payload);
  }

  addCddDisease(payload: any) {
    return this.http.post(`${this.apiUrl}/api/CDDUser/AddCDDUser_Disease`, payload);
  }

  addCddRole(payload: any) {
    return this.http.post(`${this.apiUrl}/api/CDDUser/AddCDDUser_Role`, payload);
  }

  deleteCddNationality(payload: any) {
    return this.http.post(`${this.apiUrl}/api/CDDUser/DeleteCDDUser_Nationality`, payload);
  }

  deleteCddDisease(payload: any) {
    return this.http.post(`${this.apiUrl}/api/CDDUser/DeleteCDDUser_Disease`, payload);
  }

  deleteCddRole(payload: any) {
    return this.http.post(`${this.apiUrl}/api/CDDUser/DeleteCDDUser_Role`, payload);
  }
  getFacilityMemberRole(payload: any) {
    return this.http.post(`${this.apiUrl}/api/FacilityMemberProfile/GetFacilityMemberProfileByID`, payload);
  }
  getAllRoles() {
    return this.http.get(`${this.apiUrl}/api/FacilityMemberProfile/CreateFacilityMemberProfile`);
  }

  sendBulkSMS(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Case/BulkSendSMS`, payload);
  }

  sendBulkEmail(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Case/BulkSendEmail`, payload);
  }

  bulkNotificationAssignUser(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Case/BulkNotificationAssignment`, payload);
  }

  addTeamCDDUser(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Team/AddTeam_CDDUser`, payload);
  }

  deleteTeamUser(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Team/DeleteTeam_CDDUser`, payload);
  }

  getAllCDDUserByTeamID(id: any) {
    return this.http.get(`${this.apiUrl}/api/Team/GetCDDUserByTeamID/${id}`);
  }

  getTeamsDD() {
    return this.http.get(`${this.apiUrl}/api/Team/CreateTeam`);
  }

  addTeam(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Team/CreateTeam`, payload);
  }

  getAllBulkOperation(params: any) {
    return this.http.post(`${this.apiUrl}/api/BulkRequest/GetAllBulkRequest`, params );
  }

  getBulkOperationByID(id: any) {
    return this.http.get(`${this.apiUrl}/api/BulkRequest/GetBulkRequestByID/${id}`);
  }
  GetBulkRequestFilesMergerdByID(id: any) {
    return this.http.get(`${this.apiUrl}/api/BulkRequest/GetBulkRequestFilesMergerdByID/${id}`);
  }
  getCreateBulkRequest() {
    return this.http.get(`${this.apiUrl}/api/BulkRequest/CreateBulkRequest`);
  }

  getAllPatientsData() {
    return this.http.get(`${this.apiUrl}/api/Patient/GetAllPatients`);
  }
  getAllPatientsDataPaginated(params: any) {
    return this.http.post(`${this.apiUrl}/api/Patient/GetAllPatientsPaginated`, params);
  }

  getAllCaseByPaitentId(id: string) {
    return this.http.get(`${this.apiUrl}/api/Case/GetCaseByPatientID/${id}`);
  }

  getAllContactExposureByPaitentId(params: any) {
    return this.http.get(`${this.apiUrl}/api/ContactExposure/GetContactExposureByPatientID`, { params });
  }

  addCddUser(payLoad: any) {
    return this.http.post(
      `${this.apiUrl}/api/CDDUser/CreateCDDUser`,
      payLoad
    );
  }

  exportAllCddUsers() {
    return this.http.get(`${this.apiUrl}/api/CDDUser/ExportAllCDDUser`);
  }

  GetAllExportColumns(DiseaseID: any) {
    return this.http.get(`${this.apiUrl}/api/Case/GetAllExportColumns/${DiseaseID}`);
  }

  GetDefaultExportColumns() {
    return this.http.get(`${this.apiUrl}/api/Case/GetExportDefaultColumn`);
  }

  BulkExportNotifications(payload: any) {
    return this.http.post(`${this.apiUrl}/api/Case/BulkExportNotification`, payload);
  }

  //#region FamilyBook

  GetFamilyBookFromCRM(emiratesId: any) {
    return this.http.get(`${this.apiUrl}/api/FamilyBook/GetFamilyBookFromCRM?emiratesID=${emiratesId}`);
  }

  GetNotificationById(payload: any) {
    return this.http.get(`${this.apiUrl}/api/Case/GetCaseByNotificationID/${payload?.NotificationID}`);
  }

  /* ends here */

  /* AMR Dashboard */

  GetAllAMRNotifications(params: any) {
    return this.http.post(`${this.apiUrl}/api/AMRNotification/GetAllAMRNotification_SQL`, params );
  }

  ExportAMRNotifications(params: any) {
    return this.http.post(`${this.apiUrl}/api/AMRNotification/BulkExportNotification`, params );
  }
  GetAllAMRExportColumns() {
    return this.http.get(`${this.apiUrl}/api/AMRNotification/GetAllExportColumns`);
  }


  DashboardTotalTests(params: any){
    return this.http.post(`${this.apiUrl}/api/AMRDashboard/GetAMRNotificationCounts`, params );
  }

  DashboardEmiratesNonEmirates(params: any){
    return this.http.post(`${this.apiUrl}/api/AMRDashboard/GetEmiratiorNonEmiratiNotification`,params);
  }

  DashboardAgeGroup(params: any){
    return this.http.post(`${this.apiUrl}/api/AMRDashboard/GetNotificationByAge`, params);
  }

  DashboardReportedPathogens(params: any) {
    return this.http.post(`${this.apiUrl}/api/AMRDashboard/GetPathogensCount`, params);
  }

  DashboardClinicalSamples(params: any) {
    return this.http.post(`${this.apiUrl}/api/AMRDashboard/GetClinicalSampleCount`, params);
  }

  DashboardFacilityRegions(params: any){
    return this.http.post(`${this.apiUrl}/api/AMRDashboard/GetFacilityPercentage`, params);
  }

  UpdatePatientLocation(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.apiUrl}/api/AMRNotification/UpdateAMRNotificationLocation`, payload);//, { params });
  }

  /* ends here */
  CreateAMRNotification() {
    return this.http.get(`${this.apiUrl}/api/AMRNotification/CreateAMRNotification`);
  }
  /* ends here */
  getCreateAMR() {
    return this.http.get(`${this.apiUrl}/api/AMRDatasheet/CreateAMRDatasheet`);
  }
  createAmrDatasheet(payload: any) {
    return this.http.post(`${this.apiUrl}/api/AMRDatasheet/CreateAMRDatasheet`, payload);
  }
  updateAmrDatasheet(payload: any) {
    return this.http.post(`${this.apiUrl}/api/AMRDatasheet/UpdateAMRDatasheet`, payload);
  }

  getAmrDatasheet(params: any) {
    return this.http.post(`${this.apiUrl}/api/AMRDatasheet/GetAllAMRDatasheet`,params);
  }

  getDatasheetById(id: any) {
    return this.http.get(`${this.apiUrl}/api/AMRDatasheet/GetAMRDatasheetById/${id}`);
  }

  deleteAMRDatasheet(id: any) {
    return this.http.post(`${this.apiUrl}/api/AMRDatasheet/DeleteAMRDatasheet/${id}`,'');
  }

  getAMRDatasheetFacility() {
    return this.http.get(`${this.apiUrl}/api/AMRDatasheet/GetAMRDatasheetFacility`);
  }

  getAMRDatasheetByFacilityID(id: any) {
    return this.http.get(`${this.apiUrl}/api/AMRDatasheet/GetAMRDatasheetByFacilityID?FacilityID=${id}`);
  }


  downloadAMRDatasheetByUrl(url: any) {
    const payload = {
      url
    }
    return this.http.post(`${this.apiUrl}/api/AMRDatasheet/DownloadFile`,payload);
  }


  UpdateAMRNotification(payload: any) {
    return this.http.post(`${this.apiUrl}/api/AMRNotification/UpdateAMRNotification`, payload);
  }
  
  getAllSQLAudits(params:any) {
    return this.http.get(`${this.apiUrl}/api/Audit/GetSQLAudits?recordId=${params}` );
  }
  /* ends here */
  // Audit History
  getAllAuditHistory(notificationId:any, patientId: any) {
    return this.http.get(`${this.apiUrl}/api/Audit/GetAllAudits?notificationId=${notificationId}&patientId=${patientId}` );
  }
  getAllAuditorsHistory(params:any) {
    return this.http.get(`${this.apiUrl}/api/Audit/GetAudits?recordId=${params}` );
  }
  getStagesAuditorsHistory(params:any) {
    return this.http.get(`${this.apiUrl}/api/Audit/GetStagesAudits?recordId=${params}` );
  }
  getAllUsersAuditsHistory(params:any) {
    return this.http.get(`${this.apiUrl}/api/Audit/GetAllUsersSQLAudits?recordId=${params}` );
  }
  getActionLogs(params:any) {
    return this.http.get(`${this.apiUrl}/api/Audit/GetActionLogs?notificationId=${params}` );
  }

  addCaseToCluster(obj: any) {
    return this.http.post(
      `${this.apiUrl}/api/Cluster/AddCaseIntoCluster`,
      obj
    );
  }

  removeCaseFromCluster(obj: any) {
    return this.http.post(
      `${this.apiUrl}/api/Cluster/RemoveCaseFromCluster`,
      obj
    );
  }
     //update ProbableSourceOfInfectio Case
     UpdateProbableSourceOfInfectioCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/Case/UpdateProbableSourceOfInfectioCase`, payLoad);
    }
    //update Symptoms Case
    updateSymptomsCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/Symptom/UpdateSymptomCase`, payLoad);
    }

    //update FoodHistoryCheckBox Case
    updateFoodCheckBoxCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/FoodHistoryCheckBox/UpdateCaseFoodHistoryCheckBox`, payLoad);
    }
    //update dst result Case
    updateDstResultCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/DSTResults/UpdateCaseDSTCase`, payLoad);
    }
    //update medical history Case
    updateMedicalHistoryCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/MedicalHistory/UpdateMedicalHistoryCase`, payLoad);
    }
    //update  Complication Case
    UpdateComplicationCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/Complication/UpdateComplicationCase`, payLoad);
    }
    UpdateRiskFactorCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/RiskFactor/UpdateRiskFactorCase`, payLoad);
    }
    UpdateFinalClassificationCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/FinalClassification/UpdateFinalClassificationCase`, payLoad);
    }
    UpdateAnimalExposureCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/AnimalExposure/UpdateAnimalExposureCase`, payLoad);
    }
    UpdateTravelHistoryCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/TravelHistory/UpdateTravelHistoryCase`, payLoad);
    }
    AddDetalisOfOtherCases(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/DetailsOfOtherCases/AddDetalisOfOtherCases`, payLoad);
    }

    AddHCFVisitedByAFP(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/HCFVisitedByAFP/AddHCFVisitedByAFP`, payLoad);
    }
    DeleteHCFVisitedByAFP(id: any) {
      return this.http.post(`${this.apiUrl}/api/HCFVisitedByAFP/DeleteHCFVisitedByAFP/${id}`, id);
    }
    DeleteDetalisOfOtherCases(id: any) {
      return this.http.post(`${this.apiUrl}/api/DetailsOfOtherCases/DeleteDetalisOfOtherCases/${id}`, id);
    }
    CreateFoodHistoryCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/FoodHistory/CreateFoodHistory`, payLoad);
    }
    UpdateFoodHistory(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/FoodHistory/UpdateFoodHistory`, payLoad);
    }
    DeleteFoodHistory(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/FoodHistory/DeleteFoodHistory`, payLoad);
    }
    UpdateHospitalizationCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/Hospitalization/UpdateHospitalizationCase`, payLoad);
    }
    UpdateVaccineCase(payLoad: any) {
      return this.http.post(`${this.apiUrl}/api/Vaccine/UpdateVaccineInformationCase`, payLoad);
    }
   sendBackCase(payload:any){
    const url = `${this.apiUrl}/api/Case/SendBack`;
    return  this.http.post(url, payload);

  }
  sendToAdafsa(obj:any){
    const url = `${this.apiUrl}/api/Case/SendToADAFSA`;
    return  this.http.post(url, obj);

  }
  GetAllNewRequestForRole() {
    return this.http.get(`${this.apiUrl}/api/SystemUser/GetAllNewRequestForRole`);
  }
  ApproveRequest(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/SystemUser/ApproveRequest`, payLoad);
  }
  CancelRequest(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/SystemUser/CancelRequest`, payLoad);
  }
  RequestNewRole(payLoad: any) {
    return this.http.post(`${this.apiUrl}/api/SystemUser/RequestNewRole`, payLoad);
  }
}


